<template>
  <v-card class="custom-data-card pb-2" :width="width">
    <v-list-item class="card-header">
      <v-list-item-content>
        <v-list-item-title class="card-title">
          {{ title }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="cyan-divider"></v-divider>

    <v-list
      dense
      class="custom-list pb-2 overflow-y-auto"
      :height="maxContentHeight"
    >
      <template v-for="item in header">
        <v-list-item 
          :key="item.id" 
          v-if="data?.[item.field] !== undefined" 
          >
          <v-list-item-content>{{ item.caption }} </v-list-item-content>
          <v-list-item-content>
            {{ dataValue(item) }}
          </v-list-item-content>
        </v-list-item>
      </template>

      <slot name="default"></slot>
    </v-list>
  </v-card>
</template>

<style scoped>
.text-cyan {
  color: rgba(0, 234, 255, 0.9) !important;
  text-shadow: 0 0 4px rgba(0, 234, 255, 0.3);
}
/* CARD UTAMA */
.custom-data-card {
  background-color: rgba(15, 35, 70, 0.5) !important;
  color: #00ffff !important;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 255, 255, 0.2);
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.custom-data-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 255, 255, 0.25);
}

/* HEADER */
.card-header {
  background-color: rgba(15, 35, 70, 0.5) !important;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.card-title {
  color: #00ffff !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* DIVIDER */
.cyan-divider {
  border-color: #00ffff !important;
}

/* LIST ITEM */
.custom-list {
  background-color: rgba(15, 35, 70, 0.5) !important;
  color: #00ffff !important;
  max-height: inherit;
}

.v-list-item {
  border-bottom: 1px solid rgba(0, 255, 255, 0.1);
}

.v-list-item:hover {
  /* Mempertahankan hover effect dari File Lama/Baru */
  background-color: rgba(15, 35, 70, 0.5) !important;
}

.v-list-item-content {
  color: #00ffff !important;
}

/* TEKS KHUSUS */
.cyan-text {
  color: #00ffff !important;
  font-weight: 500;
}
</style>

<script>
export default {
  data: () => ({
    showMore: false,
    rolename: "admin",
    greetingMessage: "Hello...",
  }),
  methods: {
    dataValue(item) {
      try {
        if (
          typeof this.data !== "undefined" &&
          typeof this.data[item.field] !== "undefined" &&
          this.data[item.field] !== null
        ) {
          if (item.decimal) {
            let xvalue = this.data[item.field];
            return Number(xvalue).toLocaleString("en-US", {
              minimumFractionDigits: item.decimal,
              maximumFractionDigits: item.decimal,
            });
          } else {
            return this.data[item.field];
          }
        }
        return "";
      } catch (error) {
        return "";
      }
    },
    checkRole: function () {
      return true;
    },
  },
  computed: {
    maxContentHeight() {
      // return 800
      return this.height - 56;
    },
  },
  props: {
    header: {
      type: Array,
      default: () => [], // Menggunakan sintaks Function Shorthand dari File Baru
    },
    data: {
      type: Object,
      default: () => ({}), // <-- FIX ERROR: Menggunakan default function yang mengembalikan objek kosong
    },
    title: {
      type: String,
      default: "Title",
    },
    dense: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 500,
    },
    width: {
      type: Number,
      default: undefined,
    },
  },
};
</script>